import type { ReactElement, ReactNode } from 'react'
import React from 'react'
import { css } from '@linaria/core'
import { Bleedable, colors } from '..'
import { GridStart } from '../grid'
import { ResponsiveProvider } from '../responsive'

const wrapperCss = css`
  background: ${colors.gray00};
`

type footerProps = {
  children: ReactNode
}

const InfoSheetFooter = ({ children }: footerProps): ReactElement => {
  return (
    <Bleedable as="footer" sides={16} top={16} className={wrapperCss}>
      <ResponsiveProvider>
        <GridStart>{children}</GridStart>
      </ResponsiveProvider>
    </Bleedable>
  )
}

export default InfoSheetFooter
